import { render, staticRenderFns } from "./BetterScroll.vue?vue&type=template&id=8c33584e&"
import script from "./BetterScroll.vue?vue&type=script&lang=js&"
export * from "./BetterScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports